<template>
  <v-container fluid class="pa-5">
    <v-row>
      <v-col cols="4">
        <dashboard-card
          logo=""          
          title="Pending"
          subtitle="Waybills"
          :number="dashboard.pendingWaybills"
          description=""
          icon="mdi-file-question-outline"
        ></dashboard-card>
      </v-col>
      <v-col cols="4">
        <dashboard-card
          logo=""          
          title="Approved"
          subtitle="Waybills"
          :number="dashboard.approvedWaybills"
          description=""
          icon="mdi-file-check-outline"
        ></dashboard-card>
      </v-col>
      <v-col cols="4">
        <dashboard-card
          title="Trucks"
          subtitle="Trucks on duty"
          :number="dashboard.trucks"
          color="primary"
          description=""
          icon="mdi-truck-delivery-outline"
        ></dashboard-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="user.userRoleId === 1" cols="7" style="padding:0 !important">
        <notifications 
          :title="'Notifications'"
          :table_only="true"
          :hubMethod="'cms_new_violation'"
        ></notifications>
      </v-col>
      <v-col :cols="user.userRoleId === 1 ? 5 : 12" class="pa-5">
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar class="transparent" flat>
              <v-toolbar-title>
                Real time tracking
                <v-icon color="primary" class="ml-2" v-if="loading">mdi-timer-sand</v-icon>
              </v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-btn text v-if="!autorefresh" @click="refresh" :disabled="loading">
                  <v-icon class="mr-2">mdi-refresh</v-icon>
                  Refresh
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <google-map :realtime_tracking="true" nosearch />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!--<v-row>
      <v-col>
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar class="transparent" flat>
              <v-toolbar-title>
                Packages
                <v-icon color="primary" class="ml-2" v-if="loading">mdi-timer-sand</v-icon>
              </v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <div class="d-flex py-3 mr-3">
                  <date-picker v-model="from" label="From" color="primary" textfieldClass="mr-2"/>
                  <date-picker v-model="to" label="To" color="primary" />
                </div>
                <v-btn text v-if="!autorefresh" @click="refresh" :disabled="loading">
                  <v-icon class="mr-2">mdi-refresh</v-icon>
                  Refresh
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-card-title>
          <v-divider />
        </v-card>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DashboardCard from '@/components/DashboardCard';
import DatePicker from '@/components/DatePicker';
import GoogleMap from '@/components/GoogleMap';
import Trucks from '@/views/Trucks'
import Notifications from '@/views/Notifications'

export default {
  data() {
    return {
      from: this.formatDate(new Date(Date.now() - 604800000)),
      to: this.formatDate(new Date(Date.now())),
      interval: {},
      autorefresh: false
    }
  },
  computed: {
    ...mapState("settings", ["settings"]),
    ...mapState('entities',['current_entity','entities','loading']),
    ...mapState('dashboard',['dashboard']),
    ...mapState('users',['loggedIn','user']),
    logo() {
      return "";
    },
    chart() {
      return {
        options: {
          chart: {
            id: 'votes-distribution'
          },
          xaxis: {
            categories: this.chartData.xAxis
          },
          colors: ['#4CAF50']
        },
        series: [{
          name: 'No of Votes',
          data: this.chartData.yAxis
        }]
      }
    }
  },
  components: {
    DashboardCard, DatePicker, GoogleMap, Trucks, Notifications
  },
  methods: {
    ...mapActions('entities',['getEntities','saveEntity']),
    ...mapActions('dashboard',['getDashboard']),
    refresh() {
      
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    }
  },
  mounted() {
    this.autorefresh = true
    this.getEntities('truck')
    this.getEntities('waybill')
    this.getDashboard()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  watch: {
    autorefresh(value) {
      if (value) {
        this.refresh()
        this.interval = setInterval(() => { this.refresh() }, 10000)
      } else clearInterval(this.interval)
    },
    from: 'refresh',
    to: 'refresh'
  }
};
</script>
